import posthog from 'posthog-js';
import { getEnvironment } from './pluginHelpers';
import { POSTHOG_PROJECT_IDS } from '@/constants/posthog';

const API_KEYS = {
  production: POSTHOG_PROJECT_IDS.PRODUCTION,
  staging: POSTHOG_PROJECT_IDS.STAGING,
  preprod: POSTHOG_PROJECT_IDS.STAGING,
  local: POSTHOG_PROJECT_IDS.DEVELOPMENT,
  development: POSTHOG_PROJECT_IDS.DEVELOPMENT,
};

const POSTHOG_SERVICE_URL = 'https://posthog.eagleeyenetworks.com';

export default {
  install(Vue) {
    const environment = getEnvironment();
    const apiKey = API_KEYS[environment];
    posthog.init(apiKey, {
      api_host: POSTHOG_SERVICE_URL,
      capture_pageview: false,
      capture_pageleave: false, // Opt back in because disabling $pageview capture disables $pageleave events
    });
    Vue.prototype.$posthog = posthog;
  },
};
